// extracted by mini-css-extract-plugin
export default {"nav":"Navigator_nav__xUJE1","disabled":"Navigator_disabled__GDapb"};